import React, { useState } from 'react';
import { courses } from './plans';
import '../styles/PlanButtonSelector.css';

const PlanButtonSelector = ({ onSelectCourse, initialCourse }) => {
  const [selectedCourse, setSelectedCourse] = useState(initialCourse); // 初期値をinitialCourseに設定

  const handleClick = (key) => {
    setSelectedCourse(key); // 選択したコースを更新
    onSelectCourse(key); // 親コンポーネントに通知
  };

  return (
    <div className="elt-wp-plugin button-selector-wrapper">
      <div className="selected-course-and-label">
        <label className="cp_ipselect_label">コースを選択</label>
        <span className="selected-course">選択中: {courses[selectedCourse].name}</span>
      </div>
      <div className="button-list">
        {Object.entries(courses)
          .filter(([key]) => key !== "default") // defaultを除外
          .map(([key, course]) => (
            <button
              key={key}
              className={`button-item ${selectedCourse === key ? 'selected' : ''}`}
              onClick={() => handleClick(key)}
            >
              {course.name}
            </button>
        ))}
      </div>
      <span className="cp_ipselect_message">
        ご希望のコースが見当たらない場合は
        <a href="/contact" className="contact-link">お問合せ</a>ください。
      </span>
    </div>
  );
};

export default PlanButtonSelector;

